import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { getDoc, doc, getFirestore} from 'firebase/firestore';
import NavbarCont from '../Navbar/NavbarCont';
import ArticleDetail from './ArticleDetail';
import "./articles.css"
import Footer from '../Footer/Footer';
import ArticleDetailLoader from './ArticleDetailLoader';

export default function ArticleDetailCont() {
    const db = getFirestore()
    const { id } = useParams()

    const [thisArticle, setThisArticle] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchArticleById = async () => {
      setThisArticle(null)
      try {
        const docRef = doc(db, "articles", id); // Reemplaza "collectionName" por el nombre de tu colección
        const docSnap = await getDoc(docRef);
  
        if (docSnap.exists()) {
          setThisArticle(docSnap.data());
        } else {
          console.log("No such document!");
          setError("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document: ", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
  
    useEffect(() => {
      if (id) {
        fetchArticleById(id);
      }
    }, [id]);

   
  return (
    <section className='home-cont'>
      <NavbarCont />
   
      {thisArticle ? (
        <ArticleDetail data={thisArticle} id={id} loading={loading} error={error} />
      ) : (
        <ArticleDetailLoader />
      )}

      <Footer />
    </section>
  )
}
